import React, { useContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { messages, browserLocale } from 'utils/intl';
import { isTeachers } from 'utils/checkUrl';
const initialState = {
    locale: isTeachers() ? 'ja' : browserLocale,
};
const IntlStateContext = React.createContext(initialState);
const SetLocaleStateContext = React.createContext(() => {
    // empty block
});
export function useLocaleState() {
    return useContext(IntlStateContext);
}
export function useSetLocaleState() {
    return useContext(SetLocaleStateContext);
}
export function LocaleStateProvider(props) {
    const [state, setState] = useState(props.initialState || initialState);
    return (React.createElement(IntlStateContext.Provider, { value: state },
        React.createElement(SetLocaleStateContext.Provider, { value: setState }, props.children)));
}
export const Intl = (props) => {
    const localeState = props.localeState ? props.localeState : useLocaleState();
    return (React.createElement(IntlProvider, { messages: messages[localeState.locale], locale: localeState.locale, defaultLocale: 'en' }, props.children));
};
